import React, { Component } from 'react'

class LoadingIndicator extends Component {
  render () {
    if (!this.props.visible) return null
    return (
      <div className='loading-indicator'>
        <i className='fa fa-spin fa-circle-o-notch' />
        <p className={'text-center loading-message ' + this.props.loadingMessage ? '' : 'hidden'}>{this.props.loadingMessage ? this.props.loadingMessage : ''}</p>
      </div>
    )
  }
}
export default LoadingIndicator



// WEBPACK FOOTER //
// ./src/components/basic/displays/LoadingIndicator.js